var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"step-wrapper",staticClass:"step-transition step-wrapper"},[_c('transition',{attrs:{"appear":"","name":"fade","mode":"out-in"}},[_vm._t("default")],2),_c('div',{staticClass:"scroll-arrow"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }